<template>
  <!--  <div class="product-detail" v-if="product">-->
  <!--    <h1>{{ product.title }}</h1>-->
  <!--    <p>{{ product.description }}</p>-->
  <!--    <img :src="product.image" :alt="product.title"/>-->
  <!--    &lt;!&ndash; 根据需要添加更多产品详情展示 &ndash;&gt;-->
  <!--  <div v-else class="loading">-->
  <!--    &lt;!&ndash; 显示加载提示，直到产品数据被加载 &ndash;&gt;-->
  <!--    Loading product...-->
  <!--  </div>-->
  <div class="product-detail">
    <div class="title">SC-UFM型超声波气体流量计</div>
    <ul class="content">
      <li>

        <div  class="item">
          <div>
            <div class="text-title">简介</div>
        <p>
          SC-UFM型超声波气体流量计是我公司吸收引进国内、外先进技术，结合国产微功耗大规模集成电路及计时芯片，自主研发的双声道超声波气体流量计量产品，具有高精度、高稳定性和超宽量程比等特点，具有工况和标况流量检测、频率脉冲输出、蓝牙通信、RS485通信、物联网（NB-IoT、Cat1、4G全网通）通信、4-20mA电流信号输出等功能。
        </p>
        <p>
          该产品采用流量数据压缩算法，可以解析出分钟级瞬时流量的变化 ，能精准描绘出用户用气曲线，实现用气规律大数据分析及监控。
        </p>
        <p>
          该产品整体结构采用高强度铝合金制成，钢化玻璃面板结合了大面积液晶和触摸按键,内置不锈钢整流器，造型新颖、美观大方、安装方便，在中国城市燃气协会举办的首届燃气设计美学“匠心奖”大赛中获得金奖。
        </p>
        <p>
          产品全系列覆盖DN40-DN200规格，可用于天然气等工业气体计量,可广泛应用于城市燃气、石油、化工、冶金等行业中压气体的流量计量。</p>
          </div>
       <img src="../assets/cp1.png" class="product-image" alt="产品图片"/>
        </div>

      </li>
      <li>
        <div class="text-title">技术特点</div>
        <ol>
          <li>超宽量程比可达1:180；</li>
          <li>流量计型号可选　H型：安装直管段长度要求，前10D后5D以上；
            　<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;C型：安装无前后直管段长度要求；</p>
          </li>
          <li>钢化玻璃面板结合了大面积液晶和触摸按键，造型美观大方、安装方便；</li>
          <li>液晶设计为双向显示，无需调转表体，即可翻转液晶显示界面；</li>
          <li>内置NB-IoT、Cat1、蓝牙，具有RS485、4-20mA电流环输出、频率脉冲输出等功能，可供用户选择；</li>
          <li>内置锂电池供电，寿命可达4年以上;</li>
          <li>独有的数据压缩算法及解析算法，可解析出分钟级用气数据。</li>
        </ol>
      </li>
      <li>
        <div class="text-title">适用范围</div>
        <p>
        可用于天然气等工业气体计量，可广泛应用于城市燃气、石油、化工、冶金等行业中压气体的流量计量。
        </p>
      </li>
      <li>
        <div class="text-title">技术特点</div>
        <ol>
          <li>支持蓝牙通讯，可配合手机或平板电脑软件读取表内信息、设置表内参数；</li>
          <li>流量异常、累积量存储异常等异常状态主动告警；</li>
          <li>可通过NB-IoT通讯方式可主动上传流量、累积量、温度压力等数据；</li>
          <li>支持RS485、4-20mA输出，用于上位机读取表内累积量、瞬时流量、温度压力等表内信息；</li>
          <li>支持频率脉冲输出，可用于表具检定。</li>
        </ol>
      </li>
    </ul>
  </div>

</template>

<script>
export default {
  name: "ProductDetail",
  data() {
    return {
      product: null, // 用于存储产品详情的数据对象
    };
  },
  async created() {
    try {
      const productId = this.$route.params.id; // 从路由参数中获取产品ID
      const response = await this.fetchProduct(productId); // 调用方法来获取产品详情
      this.product = response.data; // 假设响应数据中包含产品详情
    } catch (error) {
      console.error('Error fetching product:', error);
      // 可以根据需要处理错误，比如显示错误消息
    }
  },
  methods: {
    async fetchProduct(id) {
      // 发送请求到后端API获取产品详情
      // 这里使用了假设的API端点，你需要替换成实际的API地址
      const response = await fetch(`/api/products/${id}`);
      if (!response.ok) {
        throw new Error('Failed to fetch product');
      }
      return await response.json();
    },
  },
}
</script>

<style scoped>
/* 在这里添加针对手机屏幕的样式 */
.product-detail {
  width: 82%;
  margin: 15vw auto;
  text-align: left;
}

.title {
  color: #333333;
  font-size: 5vw;
  margin-bottom: 20px;
}

.content {
  font-size: 4vw;
  color: #666;
  line-height: 6.75vw;
}
.product-detail ul li {
  padding-bottom: 5.625vw;
}
.product-detail ol {
  padding-inline-start: 20px;
}
.product-detail ol li {
  padding-bottom: 0;
}
.content p {
  padding-bottom: 20px;
  text-indent: 8vw;
}
.item {
  display: flex;
  flex-direction: column-reverse;

}
.product-image {
  display: block;
  width: 70vw;
  height: 100%;
  margin: 9.375vw auto;
  padding: 20px;
  border: #999 solid 1px;
}


.text-title {
  color: #4373B3;
  font-size: 4.5vw;
  padding-bottom: 3.75vw;
}

@media (min-width: 768px) {
  .product-detail {
    width: 680px;
    margin: 80px auto;
  }

  .title {
    font-size: 30px;
    margin-bottom: 50px;
  }

  .content {
    font-size: 18px;
    line-height: 30px;
  }
  .content p {
    text-indent: 36px;
  }

  .item ol li {
    font-size: 18px;
    line-height: 30px;
    color: #666;
  }

  .text-title {
    font-size: 24px;
    padding-bottom: 22px;
  }


}

@media (min-width: 960px) {
  .product-detail {
    width: 900px;
  }
  .item {
    display: flex;
    flex-direction: row;
  }
  .item div {
    padding-right: 50px;
  }

  .product-image {
    width: 300px;
    margin: 50px auto;
  }
  .product-detail ul li {
    padding-bottom: 30px;
  }
  .product-detail ol li {
    padding-bottom: 0;
  }
}

@media (min-width: 1200px) {
  .product-detail {
    width: 1200px;
  }
  .product-image {
    width: 400px;
    margin: 50px auto;
  }
}
</style>